import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d61rgi950i17hner1qn0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setIsSuccess(true);
        setEmail('');
        setTimeout(() => setIsSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Subscription error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#1A1F2E] to-[#2D3548]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-[#C9A961]/20 rounded-full">
          <i className="ri-mail-send-line text-3xl text-[#C9A961]"></i>
        </div>
        
        <h2 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Stay Inspired
        </h2>
        
        <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
          Subscribe to our newsletter for exclusive travel tips, destination guides, 
          and special offers delivered straight to your inbox.
        </p>

        <form 
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
        >
          <input
            type="email"
            name="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="flex-1 px-5 py-4 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/50 text-sm focus:outline-none focus:border-[#C9A961] transition-colors"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-8 py-4 bg-[#C9A961] text-white rounded-xl text-sm font-semibold hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>

        {isSuccess && (
          <div className="mt-4 px-4 py-3 bg-green-500/20 border border-green-500/30 rounded-lg inline-block">
            <p className="text-green-400 text-sm font-medium">
              <i className="ri-check-line mr-2"></i>
              Thank you for subscribing!
            </p>
          </div>
        )}

        <p className="text-white/50 text-xs mt-6">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </section>
  );
}
